import { trpc } from "@/lib/trpc";

export const useSettingsQuery = (enabled?: boolean) =>
    trpc.settings.findOne.useQuery(undefined, {
        enabled,
        staleTime: 5 * 60 * 1000, // 5 minutes instead of Infinity to allow refetching
        refetchOnWindowFocus: false,
        refetchOnMount: true,
    });
